// import { Injectable } from '@angular/core';
// import { Socket } from 'ngx-socket-io';
// import { Observable } from 'rxjs';

// @Injectable({
//   providedIn: 'root',
// })
// export class ChatService {
//   constructor(private socket: Socket) {}

//   // Register the user with their userId (called after login)
//   registerUser(userId: number) {
//     this.socket.emit('registerUser', userId);
//   }

//   // Send message to the backend
//   sendMessage(messageData: { 
//     content: string; 
//     rfqId: number; 
//     senderId: number; 
//     receiverId: number 
//   }) {
//     console.log('Sending message in Chat.Service.ts:', messageData);
//     this.socket.emit('sendMessage', messageData);
//   }

//   // Get new incoming messages (real-time push)
//   getMessages(): Observable<any> {
//     return this.socket.fromEvent('receiveMessage');
//   }

//   // Typing indicator (frontend → backend)
//   sendTypingNotification(receiverId: number, rfqId: number) {
//     this.socket.emit('typingNotification', { receiverId, rfqId });
//   }

//   // Listen for typing notifications (backend → frontend)
//   getTypingNotification(): Observable<any> {
//     return this.socket.fromEvent('typingNotification');
//   }
// }


import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private socket!: WebSocket;
  private messageSubject = new Subject<any>();
  private typingSubject = new Subject<any>();
  private connected$ = new BehaviorSubject<boolean>(false);

  constructor(private ngZone: NgZone,private webApiService: WebApiService) {}

  connect() {
    this.socket = new WebSocket('ws://localhost:3001'); 
    // this.socket = new WebSocket('http://localhost:3001'); 
    // In production: wss://<api-id>.execute-api.<region>.amazonaws.com/dev
    console.log("socket",this.socket);
    this.socket.onopen = () => {
      console.log('✅ Connected to WebSocket');
      this.connected$.next(true);
    };

    

    this.socket.onmessage = (event) => {
      const data = JSON.parse(event.data);

      this.ngZone.run(() => {
        if (data.type === 'receiveMessage') {
          this.messageSubject.next(data);
        } else if (data.type === 'typingNotification') {
          this.typingSubject.next(data);
        } else {
          console.log('📩 Unknown WS event:', data);
        }
      });
    };

    this.socket.onclose = () => {
      console.log('❌ WebSocket closed');
      this.connected$.next(false);
    };
  }

  onConnected(): Observable<boolean> {
  return this.connected$.asObservable();
}

  // 👉 Register user with backend
  registerUser(userId: number) {
    console.log('Register function called');
    console.log('Registering user with ID (in service):', userId);
    this.send({
      action: 'registerUser',
      userId,
    });
  }

  // 👉 Send chat message
  // async sendMessage(messageData: {
  //   content: string;
  //   rfqId: number;
  //   senderId: number;
  //   receiverId: number;
  // },isSupplier: boolean) {
  //   console.log('Sending message via WS:', messageData);
  //   this.send({
  //     action: 'sendMessage',
  //     ...messageData,
  //   });

  //   const enrichedMessage = {
  //     ...messageData,
  //     isSupplier,
  //   };
  //   let apiUrl = `/chat/send`;
  //   return this.webApiService.postRequest<any>(apiUrl,enrichedMessage);
  // }

  async sendMessage(messageData: {
    content: string;
    rfqId: number;
    senderId: number;
    receiverId: number;
    isSupplier: boolean;
  }) {
    console.log('Sending message via WS:', messageData);
    this.send({
      action: 'sendMessage',
      ...messageData,
    });

    // Also persist via HTTP API to trigger notifications for both buyer and supplier
    try {
      await this.webApiService.postRequest<any>('/chat/send', messageData);
    } catch (err) {
      console.error('Failed to persist chat message via API:', err);
    }
  }


  // 👉 Subscribe to new messages
  getMessages(): Observable<any> {
    return this.messageSubject.asObservable();
  }

  getChatHistory(messageData: {
    rfqId: number;
    buyerId: number;
    supplierId: number;
  }){
    let apiUrl = `/chat/history`;
    // return this.webApiService.postRequest<any>(apiUrl,messageData);
    return from(this.webApiService.postRequest<any>(apiUrl, messageData));
  }

  getUnreadCounts(buyerId: number) {
    return from(this.webApiService.postRequest<any>('/chat/unread-counts', { buyerId }));
  }

  markAsRead(params: { rfqId: number; buyerId: number; supplierId: number; userId: number }) {
    return from(this.webApiService.postRequest<any>('/chat/mark-read', params));
  }

  // 👉 Send typing indicator
  sendTypingNotification(senderId: number, receiverId: number, rfqId: number) {
    this.send({
      action: 'typingNotification',
      senderId,
      receiverId,
      rfqId,
    });
  }

  // 👉 Subscribe to typing notifications
  getTypingNotification(): Observable<any> {
    return this.typingSubject.asObservable();
  }

  // ✅ Helper to send data safely
  private send(data: any) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
    } else {
      console.error('WebSocket not connected yet.');
    }
  }
}
